import { FeedbackMitigationEntryStatus, FeedbackRelatedEntry } from '../type';

export const isMitigationActionExecutable = (
  relatedEntry: FeedbackRelatedEntry
): boolean => {
  return relatedEntry.status === FeedbackMitigationEntryStatus.INITIALIZED;
};

export const MITIGATION_ENTRIES_FETCH_PAGE_SIZE = 100;

export const getAllExecutableFeedbackEntries = async (
  fetchPage: (
    offset: number,
    limit: number
  ) => Promise<{ contentList: FeedbackRelatedEntry[]; total: number }>
): Promise<FeedbackRelatedEntry[]> => {
  const pageSize = MITIGATION_ENTRIES_FETCH_PAGE_SIZE;
  const firstPage = await fetchPage(0, pageSize);
  const entries = firstPage.contentList.filter(isMitigationActionExecutable);

  for (let offset = pageSize; offset < firstPage.total; offset += pageSize) {
    const page = await fetchPage(offset, pageSize);
    entries.push(...page.contentList.filter(isMitigationActionExecutable));
  }

  return entries;
};
